import { render, staticRenderFns } from "./BatchTableFooter.vue?vue&type=template&id=4692a45c&"
import script from "./BatchTableFooter.vue?vue&type=script&lang=js&"
export * from "./BatchTableFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1676214312/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4692a45c')) {
      api.createRecord('4692a45c', component.options)
    } else {
      api.reload('4692a45c', component.options)
    }
    module.hot.accept("./BatchTableFooter.vue?vue&type=template&id=4692a45c&", function () {
      api.rerender('4692a45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BatchTables/SharedElements/BatchTableFooter.vue"
export default component.exports